import { onMounted, onUnmounted, ref } from 'vue'

export interface UsePdfh5RendererOptions {
  /** PDF 容器选择器 */
  selector: string
  /** PDF 文件地址 */
  pdfurl: string
  /** 是否允许缩放，默认 true */
  scalable?: boolean
}

/**
 * 封装 pdfh5 的加载、初始化与销毁
 * @param options - 渲染配置
 * @returns 渲染状态
 */
export function usePdfh5Renderer(options: UsePdfh5RendererOptions) {
  const pdfInstance = ref<any>(null)
  const loading = ref(false)
  let isUnmounted = false

  onMounted(async () => {
    if (!options.pdfurl) return
    loading.value = true

    try {
      // pdfh5 类型声明见 shared/types/src/pdfh5.d.ts
      const Pdfh5 = (await import('pdfh5')).default
      if (isUnmounted) return

      const container = document.querySelector(options.selector)
      if (!container) {
        console.warn(`Pdfh5 container not found: ${options.selector}`)
        return
      }

      pdfInstance.value = new Pdfh5(options.selector, {
        pdfurl: options.pdfurl,
        scale: options.scalable !== false ? 1.5 : undefined,
      })
    } catch (err) {
      if (isUnmounted) return
      console.error('pdfh5 load failed', err)
    } finally {
      if (!isUnmounted) loading.value = false
    }
  })

  onUnmounted(() => {
    isUnmounted = true
    if (pdfInstance.value && typeof pdfInstance.value.destroy === 'function') {
      pdfInstance.value.destroy()
    }
    pdfInstance.value = null
  })

  return { pdfInstance, loading }
}
